import { module } from 'angular';

import { ConferenceDeprecatedService, default as conferenceServiceName } from './conference-deprecated.service';

export default module('contact.agent.core.phone.conference', []).service(conferenceServiceName, ConferenceDeprecatedService).name;
